module.exports = __webpack_public_path__ + "static/media/car-kids-monster-svgrepo-com.a0777709.svg";